export default __webpack_public_path__ + "static/media/promo.4838d951.csv";